import { Component, Input, ViewEncapsulation, OnInit, Output, EventEmitter } from '@angular/core';
import * as helpers from '../../../shared/helpers';
import * as stageTypes from '../../types';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'tr-html-content',
  templateUrl: './html-content.component.html',
  //styleUrls: ['./html-content.component.scss'],
})
export class HtmlContentComponent implements OnInit {
  @Input() additionalClasses: string;
  @Input() header: string;
  @Input() content: string;
  @Input() actions: stageTypes.IAction[];
  @Input() isDownloading$: Observable<boolean>;
  @Input() currentAction$: Observable<string>;
  @Output() action = new EventEmitter<string>();
  
  private isIframe: boolean = false;

  constructor() { }
  
  ngOnInit() {
    this.isIframe = this.detectIframeContent();
  }

  private detectIframeContent(): boolean {
    return _.includes(this.content, 'iframe');
  }

  onAction(actionName: string): void {
    this.action.emit(actionName);
  }

  getIco(action: stageTypes.IAction): string {
    if (_.has(action, 'iconclass')) {
      return action.iconclass;
    } else {
      return `ico-${action.name.toLowerCase()}`;
    }
  }

  decode(text: string) {
    return helpers.deentitize(text);
  }
}



// WEBPACK FOOTER //
// ./src/app/stage/components/html-content/html-content.component.ts